import generateTypes from '../utils/generateTypes';

export const GET_MEETINGS = generateTypes('GET_MEETINGS');
export const RESET_MEETINGS = generateTypes('RESET_MEETINGS');
